import { ShieldCheck, Wrench, Activity, HeartHandshake, Award } from "lucide-react";

const POINTS = [
  { icon: Award, label: "85,000+ installations across the U.S." },
  { icon: Wrench, label: "Professional installation crews" },
  { icon: Activity, label: "Long-term production monitoring" },
  { icon: ShieldCheck, label: "10-year workmanship warranty" },
  { icon: ShieldCheck, label: "25-year production guarantee" },
  { icon: HeartHandshake, label: "Dedicated customer support" },
];

export default function WhyION() {
  return (
    <section className="py-20 md:py-28 bg-[#F7F4EB]" data-testid="why-ion-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-5">
          <div className="eyebrow">Why I Work With ION Solar</div>
          <h2 className="mt-3 font-serif-display text-3xl md:text-5xl font-semibold text-[#0F382C] leading-tight">
            A trusted company behind a personal experience.
          </h2>
        </div>
        <div className="lg:col-span-7">
          <p className="text-lg text-slate-600 leading-relaxed">
            I wanted to work with a company capable of providing the equipment, installation quality, warranties, monitoring, and long-term support homeowners deserve. ION Solar gives me the resources to provide a premium solar experience while I remain your personal local point of contact.
          </p>

          <div className="mt-8 grid sm:grid-cols-2 gap-3">
            {POINTS.map((p, i) => (
              <div key={i} className="card-warm p-4 flex items-start gap-3">
                <div className="w-9 h-9 rounded-lg bg-[#0F382C] flex items-center justify-center shrink-0">
                  <p.icon className="w-4 h-4 text-[#FEF3C7]" />
                </div>
                <div className="text-sm text-[#0F382C] font-medium leading-snug pt-1.5">{p.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
